import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class BiathlonPicture implements ISerialize {
    public ID: number;

    public DeviceID: string | null;

    public HitStatus: string | null;

    public HitTime: Date;

    public Lane: number;

    public RelativePictureUrl: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        DeviceID?: string | null;
        HitStatus?: string | null;
        HitTime?: Date;
        Lane?: number;
        RelativePictureUrl?: string | null;
    }) {
        this.ID = values.ID ?? 0;

        this.DeviceID = values.DeviceID ?? '';

        this.HitStatus = values.HitStatus ?? '';

        this.HitTime = values.HitTime ?? new Date('1970-01-01T00:00:00.000');

        this.Lane = values.Lane ?? 0;

        this.RelativePictureUrl = values.RelativePictureUrl ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"DeviceID": ${JSON.stringify(this.DeviceID)}` +
            ',' +
            `"HitStatus": ${JSON.stringify(this.HitStatus)}` +
            ',' +
            `"HitTime": ${'"' + formatDateIso(this.HitTime) + '"'}` +
            ',' +
            `"Lane": ${JSON.stringify(this.Lane)}` +
            ',' +
            `"RelativePictureUrl": ${JSON.stringify(this.RelativePictureUrl)}` +
            '}'
        );
    }

    /**
     * Creates an instance of BiathlonPicture from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        DeviceID?: string | null;
        HitStatus?: string | null;
        HitTime?: Date;
        Lane?: number;
        RelativePictureUrl?: string | null;
    }): BiathlonPicture {
        return new BiathlonPicture(values);
    }

    public static _FromServerJson(json: any): BiathlonPicture {
        return new BiathlonPicture({
            ID: json.ID,
            DeviceID: json.DeviceID ?? '',
            HitStatus: json.HitStatus ?? '',
            HitTime: json.HitTime instanceof Date ? json.HitTime : new Date(json.HitTime),
            Lane: json.Lane,
            RelativePictureUrl: json.RelativePictureUrl ?? '',
        });
    }

    /**
     * Creates an instance of BiathlonPicture from another instance of BiathlonPicture.
     * @param other The BiathlonPicture you want to clone
     * @returns A cloned BiathlonPicture
     */
    public static FromOther(other: BiathlonPicture): BiathlonPicture {
        return BiathlonPicture._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return BiathlonPicture.FromOther(this);
    }

    static NAME_OF_CLASS = 'BiathlonPicture';
}
